// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/@microbadevs/report/~/sweetalert2/src/sweetalert2.scss
// module id = PFTI
// module chunks = 1